import React from 'react'

const ProgressBar = ({progress}) => {
  return <div className='progressbar__container'>
    <div className='progressbar__simple' style={{width: `${progress}%`}} />
  </div>
}

export default ProgressBar
